import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {SharedService} from "../../../services/common/shared.service";
import {MatDialog} from "@angular/material/dialog";
import {ReferenceSelectComponent} from "../../select/reference-select/reference-select.component";
import {NotificationService} from "../../../services/common/notification.service";
import {References} from "../../../dtos/references";
import {Router} from "@angular/router";
import {navigateToSearchResult} from "../../../shared/search/search-navigation";
import {Country} from "../../../shared/Country";

const COUNTRY_FLAGS: Partial<Record<Country, string>> = {
  [Country.GERMANY]: 'assets/flags/flag-d.svg',
  [Country.AUSTRIA]: 'assets/flags/flag-a.svg',
  [Country.SWITZERLAND]: 'assets/flags/flag-ch.svg',
  [Country.DACH]: 'assets/flags/flag-dach.svg',
  [Country.AD]: 'assets/flags/flag-ad.svg',
  [Country.DCH]: 'assets/flags/flag-dch.svg',
  [Country.ACH]: 'assets/flags/flag-ach.svg',
};

@Component({
  selector: 'app-reference-table',
  templateUrl: './reference-table.component.html',
  styleUrl: './reference-table.component.scss',
  standalone: false
})
export class ReferenceTableComponent implements OnChanges, OnInit {
  @Input() entry: References
  @Input() editMode: boolean;
  @Input() clickableRefs: boolean;
  // id and type of the entity being edited, so it can be excluded from its own reference search
  @Input() selfId: number | null = null;
  @Input() selfType: string | null = null;
  @Output() entryChange = new EventEmitter<References>();
  entries: [any][any] // TODO string, object with link

  displayedColumns: string[] = ['attribute', 'value'];

  constructor(private sharedService: SharedService, private dialog: MatDialog,
              private notificationService: NotificationService, private router: Router) {
  }

  ngOnInit() {
    if (this.entry !== undefined && this.entry !== null) {
      this.entries = this.entryToEntries(this.entry);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['entry'] && !changes['entry'].firstChange) {
      this.entries = this.entryToEntries(this.entry)
    }
  }

  private entryToEntries(entry: References) {
    const tmpEntries = this.sharedService.filterNullOrEmpty(entry)
    const labelMap: Record<string, string> = {
      vocabCategories: 'Wortschatzthemen',
      vocabEntries: 'Wortschatzeintrag',
      functionalGrammarCategories: 'funktionale Grammatik Thema',
      functionalGrammarEntries: 'funktionale Grammatik Eintrag',
      systemicGrammarCategories: 'systematische Grammatik Thema',
      systemicGrammarEntries: 'systematische Grammatik Eintrag',
      textPatterns: 'Textmuster',
      textTypes: 'Textsorte',
      detailedCanDoStatementCategories: 'detailierte Kannbeschreibungsthemen',
      detailedCanDoStatementEntries: 'detailierte Kannbeschreibungseinträge',
      globalCanDoStatementCategories: 'globale Kannbeschreibungsthemen',
      globalCanDoStatementEntries: 'globale Kannbeschreibungseinträge'
    };
    return tmpEntries.map(([key, items]) => {
      const label = labelMap[key]
      // add german labels and the typeOf for each object
      return [
        label,
        items.map((item: any) => ({
          ...item,
          typeOf: key
        }))
      ];
    });
  }

  edit() {
    const dialog = this.dialog.open(ReferenceSelectComponent,
      {data: {...this.entry, selfId: this.selfId, selfType: this.selfType}})

    dialog.afterClosed().subscribe({

      next: result => {
        if (result === undefined) return
        this.entries = this.entryToEntries(result)
        this.entryChange.emit(result)

      },
      error: error => {
        this.notificationService.openSnackBar(error)
      }
    })
  }

  openDetails(item: any) {
    if (!navigateToSearchResult(this.router, item.typeOf, item.id)) {
      this.notificationService.openSnackBar('Derzeit wird diese Funktion für diese Art nicht unterstützt')
    }
  }

  countryFlagSrc(item: any): string | undefined {
    return COUNTRY_FLAGS[item.country as Country];
  }

}
